import { useState } from 'react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'
import ModalComponent from 'components/common/ModalComponent'
import FormFooter from 'components/System/FormFooter'

// Confirmation for status changes and deletes. With confirmText, the user has to
// type it (e.g. the farm name) before confirming.
const ConfirmModal = ({ isOpen, title, message, confirmLabel, confirmText = null, danger = false, onConfirm, onClose }) => {
  const { t } = useTranslation()
  const [saving, setSaving] = useState(false)

  const handleConfirm = async () => {
    setSaving(true)
    try {
      await onConfirm()
    } finally {
      setSaving(false)
    }
  }

  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      title={title || ''}
      onSave={handleConfirm}
      maxWidth='md'
      hideDefaultFooter
    >
      {({ formData, handleChange }) => (
        <div className='flex flex-col items-center gap-4 py-2'>
          <ExclamationTriangleIcon className={`w-12 h-12 ${danger ? 'text-red-400' : 'text-amber-400'}`} />
          <p className='text-sm text-gray-700 text-center'>{message}</p>
          {confirmText && (
            <label className='w-full text-sm text-gray-700'>
              {t('system.tenants.confirm.typeToConfirm', { text: confirmText })}
              <input
                type='text'
                name='confirmation'
                value={formData.confirmation || ''}
                onChange={handleChange}
                className='w-full mt-1 p-2 border rounded-md shadow-sm'
              />
            </label>
          )}
          <div className='flex justify-end gap-3 w-full mt-2'>
            <FormFooter
              onClose={onClose}
              saving={saving}
              danger={danger}
              submitLabel={confirmLabel}
              disabled={!!confirmText && formData.confirmation !== confirmText}
            />
          </div>
        </div>
      )}
    </ModalComponent>
  )
}

export default ConfirmModal
